import { Injectable } from '@angular/core';
import { SuperHttpClientProvider } from '@app/core/http';
import { Observable } from 'rxjs';
import {
  PestModelCatalogParams,
  PestModelCatalogResponse
} from '@models/pest-models';

@Injectable({
  providedIn: 'root'
})
export class PestModelsApiService {
  constructor(private $http: SuperHttpClientProvider) {}

  getCatalog(
    idFinca: number,
    params?: PestModelCatalogParams
  ): Observable<PestModelCatalogResponse> {
    const query: Record<string, any> = {};
    if (params?.includeState !== undefined) {
      query.includeState = params.includeState ? 1 : 0;
    }
    if (params?.includeInsights !== undefined) {
      query.includeInsights = params.includeInsights ? 1 : 0;
    }
    if (params?.onlyActive !== undefined) {
      query.onlyActive = params.onlyActive ? 1 : 0;
    }
    if (params?.limit !== undefined && params.limit !== null) {
      query.limit = params.limit;
    }

    return this.$http.default.get(`/pest-model/catalog/${idFinca}`, {
      params: query
    });
  }
}
